function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.5745 12C12.2572 12 12 12.4477 12 13C12 13.5523 12.2572 14 12.5745 14H30.9596C31.2769 14 31.5341 13.5523 31.5341 13C31.5341 12.4477 31.2769 12 30.9596 12H12.5745ZM12.5812 18C12.2602 18 12 18.4477 12 19C12 19.5523 12.2602 20 12.5812 20H27.0461C27.3671 20 27.6273 19.5523 27.6273 19C27.6273 18.4477 27.3671 18 27.0461 18H12.5812ZM12 25C12 24.4477 12.2572 24 12.5745 24H30.9596C31.2769 24 31.5341 24.4477 31.5341 25C31.5341 25.5523 31.2769 26 30.9596 26H12.5745C12.2572 26 12 25.5523 12 25ZM12.5812 29.9999C12.2602 29.9999 12 30.4477 12 30.9999C12 31.5522 12.2602 31.9999 12.5812 31.9999H27.0461C27.3671 31.9999 27.6273 31.5522 27.6273 30.9999C27.6273 30.4477 27.3671 29.9999 27.0461 29.9999H12.5812Z",
  fill: "white"
});

var SvgIconHamburguesa = function SvgIconHamburguesa(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconHamburguesa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IconHamburguesa.ed8ea736.svg";
export { ForwardRef as ReactComponent };